import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import Badge from "@mui/material/Badge";
import { RoleContext } from "../RoleContext";

import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Table from "../Theme/Table";
import Edit from "./Edit";
import AddCompany from "./AddCompany";
import DeleteConfirmation from "../deleteConfirmation";
import { handleExportClickDriver } from "../exportDriverFile";
import { Checkbox, Modal } from "antd";
import ReactToPrint from "react-to-print";
import CompanyListss from "../reports/CompanyLists";
import ActionButtons from "../ActionButton";
import Spinner from "../Spinner";

import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';


function CompanyList() {
  const edit = "company";
  const detail = "viewCompany";

  let [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [id, setId] = useState(null);
  const navigate = useNavigate();

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);

  const params = useParams();
  const ids = params.id;
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);

  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const [displayAddCreditModal, setDisplayAddCreditModal] = useState(false);
  const showAddCreditModal = (id) => {
    let roleId = JSON.parse(localStorage.getItem("userData")).roleId;
    if (roleId === 30 || roleId === 31) {
      setId(roleId);
    } else {
      setId(id);
    }

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      setDisplayAddCreditModal(true);
    });
  };

  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this company`);
    setDisplayConfirmationModal(true);
  };
  const showEditModal = (id) => {
    setId(id);

    axios.get("/company/" + id, {}).then((res) => {
      setData(res.data.company);
      setDisplayEditModal(true);
    });
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const submitDelete = (id) => {
    console.log(id);
    deleteCompany(id);
    getCompanies();
    setDisplayConfirmationModal(false);
  };
  const deleteCompany = async (id) => {
    const response = await axios.delete("/company/" + id, {
      data: { id: id },
    });
    getCompanies();
  };

  const notify = () =>
    toast.success("Company list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getCompanies();
  }, [location.key]);

  const getCompanies = async () => {
    try {
      const response = await axios
        .get("companies")
        .then((res) => {
          setCompanies(res.data);
          setLoading(false);
          notify();
        })
        .catch((err) => {
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          { Header: "ID", accessor: "id" },
          { Header: "Company Name", accessor: "companyName" },
          { Header: "Contact Person", accessor: "contactPerson" },
        ],
      },
      {
        Header: "Info",
        columns: [
          { Header: "Phone", accessor: "phoneNumber" },
          { Header: "Address", accessor: "address" },
          { Header: "Balance", accessor: "balance", Cell: (row) => row.value.toFixed(2) },
          { Header: "Credit Limit", accessor: "creditLimit" },
          { Header: "Start Date", accessor: "startDate", Cell: (row) => new Date(row.value).toLocaleString() },
          { Header: "End Date", accessor: "endDate", Cell: (row) => new Date(row.value).toLocaleString() },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (row) => {
              const status = row.cell.row.original.status;
              return (
                <Chip 
                  label={status} 
                  color={status === "Active" ? "success" : "warning"}
                  variant="filled"
                  sx={{
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    boxShadow: status === "Active" 
                      ? '0 2px 4px rgba(0,255,0,0.2)' 
                      : '0 2px 4px rgba(255,165,0,0.2)'
                  }}
                />
              );
            },
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div style={{ 
                display: "flex", 
                gap: "15px", 
                alignItems: 'center' 
              }}>
                {role.filter(e => e.perm_name === "edit_driver").length > 0 && (
                  <Tooltip title="Edit Driver">
                    <span>
                      <EditIcon 
                        color="primary" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#1e40af'
                          }
                        }}
                        onClick={() => showEditModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "view_driver").length > 0 && (
                  <Tooltip title="View Driver Details">
                    <span>
                      <VisibilityIcon 
                        color="success" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#16a34a'
                          }
                        }}
                        onClick={() => navigate(`/${detail}/${row.cell.row.original.id}`)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "delete_driver").length > 0 && (
                  <Tooltip title="Delete Driver">
                    <span>
                      <DeleteIcon 
                        color="error" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#ff0000'
                          }
                        }}
                        onClick={() => showDeleteModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    [role]
  );

  const columns_expo = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor3: "companyName",
      },

      {
        Header: "Contact P",
        accessor: "contactPerson",
      },

      {
        Header: "Phone",
        accessor: "phoneNumber",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Balance",
        accessor: "balance",
      },
      {
        Header: "Credit Limit",
        accessor: "creditLimit",
      },
      {
        Header: "Start Date",
        accessor: "startDate",
      },
      {
        Header: "End Date",
        accessor: "endDate",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClickDriver(
      companies,
      columns_expo,
      selectedColumns,
      "Company",
      "company.pdf"
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const printableRef = useRef(null);

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };
  return (
    <div className="col-12" ref={printableRef} style={{ paddingLeft: 0 }}>
      <div className="card">
        <ActionButtons title="Company List" showModal={showModal} showAddModal={showAddModal}/>
          {/* <h3 className="card-title">Company List</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "auto",
              gap: "10px",
            }}
          > */}
            {/* <Button
              onClick={() => showAddModal()}
              className="btn btn-success bt"
            >
              Add Company
            </Button> */}
            {/* <Button onClick={showModal} className="btn btn-success bt">
              Export
            </Button> */}
          {/* </div> */}

          <Modal
          style={{marginTop: "60px"}}
            title="Select Columns to Export"
            visible={isModalVisible}
            onOk={handleOkModal}
            onCancel={handleCancel}
            footer={[
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button
                style={{ marginLeft: "10px" }}
                key="ok"
                type="primary"
                onClick={handleOkModal}
              >
                OK
              </Button>,
            ]}
          >
            
            <div style={{ marginBottom: "20px" }}>
              {columns_expo.map((column) => (
                <div key={column.Header} style={{ marginBottom: "10px" }}>
                  <Checkbox
                    checked={selectedColumns.includes(column.Header)}
                    onChange={() => handleColumnToggle(column.Header)}
                    style={{ marginRight: "10px", fontSize: "16px" }}
                  >
                    {column.Header}
                  </Checkbox>
                </div>
              ))}
            </div>
          </Modal>

        <div className="card-body">
          {loading ? (
            <Spinner />
          ) : (
            <Table
              columns={columns}
              data={companies}
              edit={edit}
              detail={detail}
            />
          )}
        </div>
      </div>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      <AddCompany
        getCompanies={getCompanies}
        showModal={displayAddModal}
        hideModal={hideAddModal}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          getCompanies={getCompanies}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )}
    </div>
  );
}

export default CompanyList;
